import { lookupGetStateOld } from 'legacy/lut/store'
import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { IMarkets } from 'core/classes/models/IMarkets'
import { ICountry } from 'core/classes/models/IReference'
import { MarketApi } from 'core/classes/services/api/MarketApi'
import { Crud } from 'core/types/Crud'

export const useFilterAreaCrud = (market: string) => {
  const countries = lookupGetStateOld().references.countries
  const marketsCrud = useMemo(() => {
    const markets = MarketApi.fetchMarkets().items
    return new Crud({
      fetcher: new Static([...markets] as IMarkets[]),
      keyField: 'Market',
      defaultPaging: { page: 0, pageSize: markets.length },
      defaultSort: { field: 'Market', dir: 'asc' },
    })
  }, [])

  const countriesCrud = useMemo(() => {
    const allCountries = lookupGetStateOld().references.countries
    if (!allCountries || !allCountries.length) {
      return new Crud({
        fetcher: new Static([] as ICountry[]),
        keyField: 'name',
      })
    }
    if (!market) {
      return new Crud({
        fetcher: new Static([] as ICountry[]),
        keyField: 'name',
      })
    }
    const countries = allCountries.filter((c: ICountry) => c.market === market)
    if (!countries || !countries.length) {
      return new Crud({
        fetcher: new Static([] as ICountry[]),
        keyField: 'name',
      })
    }

    return new Crud({
      fetcher: new Static(countries),
      keyField: 'name',
      defaultPaging: { page: 0, pageSize: countries.length },
      defaultSort: { field: 'name', dir: 'asc' },
    })
  }, [market, countries])

  return { marketsCrud, countriesCrud }
}
